import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';

export default function CanvasFormChildDocumentsReducer(state = initialState.canvasFormChildDocuments, action) {
	switch (action.type) {
		case types.GET_CANVAS_FORM_CHILD_DOCUMENTS: {
			let documentList = action?.response;
			if (documentList && _.size(documentList) > 0) {
				if (action?.payload?.excludeDaasInprogressDocuments) {
					documentList.data = Utility.excludeDaasInprogressDocuments(documentList.data);
				}
				let newState = {...state};
				newState[action.documentId] = documentList;
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}
